import type { Option } from '@/modules/common/types/option.type.ts';

export type CounterpartyAddressItem = {
  id: string;
  type: Option;
  address: string;
  comment: string;
};

export type CounterpartyAddressForm = {
  addresses: CounterpartyAddressItem[];
};

export function createEmptyAddressForm(): CounterpartyAddressForm {
  return {
    addresses: [],
  };
}
